import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "vtwo:file:text-foreground vtwo:placeholder:text-muted-foreground vtwo:selection:bg-primary vtwo:selection:text-primary-foreground vtwo:dark:bg-input/30 vtwo:border-input vtwo:flex vtwo:h-9 vtwo:w-full vtwo:min-w-0 vtwo:rounded-md vtwo:border vtwo:bg-transparent vtwo:px-3 vtwo:py-1 vtwo:text-base vtwo:shadow-xs vtwo:transition-[color,box-shadow] vtwo:outline-none vtwo:file:inline-flex vtwo:file:h-7 vtwo:file:border-0 vtwo:file:bg-transparent vtwo:file:text-sm vtwo:file:font-medium vtwo:disabled:pointer-events-none vtwo:disabled:cursor-not-allowed vtwo:disabled:opacity-50 vtwo:md:text-sm",
        "vtwo:focus-visible:border-ring vtwo:focus-visible:ring-ring/50 vtwo:focus-visible:ring-[3px]",
        "vtwo:aria-invalid:ring-destructive/20 vtwo:dark:aria-invalid:ring-destructive/40 vtwo:aria-invalid:border-destructive",
        className
      )}
      {...props}
    />
  )
}

export { Input }
